import { Specifications } from '$templates/pages/components/P50ProductDetailPage/components/pdp-specifications/specifications';
import React, { FC } from 'react';

export const PdpSpecifications: FC = () => {
    return <Specifications />;
};
